import React from 'react';
import './Cali.css'; 

const Florencia = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKFL.pdf" target="_blank" rel="noreferrer">Aeropuerto Gustavo Artunduaga Paredes</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 12</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1E.pdf" target="_blank" rel="noreferrer">EDPI1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1E.pdf" target="_blank" rel="noreferrer">GAXA2G</a></th>
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/GAXA3H.pdf" target="_blank" rel="noreferrer">GAXA3H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/GAXA3H.pdf" target="_blank" rel="noreferrer">PADA3F</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 30</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1D.pdf" target="_blank" rel="noreferrer">EDPI1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1D.pdf" target="_blank" rel="noreferrer">GAXA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/GEBU2A.pdf" target="_blank" rel="noreferrer">GEBU2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/GEBU2A.pdf" target="_blank" rel="noreferrer">KUDG2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/GEBU2A.pdf" target="_blank" rel="noreferrer">VUKT1D</a></th>
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 12</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">EDPI1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">GAXA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">GEBU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">KUDG1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">VUKT1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1G.pdf" target="_blank" rel="noreferrer">EDPI1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1G.pdf" target="_blank" rel="noreferrer">KUDG3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/PADA2G.pdf" target="_blank" rel="noreferrer">PADA2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/PADA2G.pdf" target="_blank" rel="noreferrer">REPE2A</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 30</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">EDPI1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">GAXA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">GEBU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">KUDG1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1F.pdf" target="_blank" rel="noreferrer">VUKT1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1G.pdf" target="_blank" rel="noreferrer">EDPI1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/EDPI1G.pdf" target="_blank" rel="noreferrer">KUDG3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/PADA2G.pdf" target="_blank" rel="noreferrer">PADA2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/PADA2G.pdf" target="_blank" rel="noreferrer">REPE2A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 12</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/VORA3012.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 30</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKFL/VORA3012.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Florencia;